/**
 * <s-compare-slider> — before/after image comparison.
 *
 * Markup contract: a child input[type="range"][data-compare-range] (0–100). Its value is
 * mirrored to the --compare-position custom property, which the template's clip-path
 * and divider read. The native range input keeps keyboard and screen-reader support.
 */
class SCompareSlider extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const range = this.querySelector('input[type="range"][data-compare-range]');
    if (!(range instanceof HTMLInputElement)) return;

    const update = () => {
      this.style.setProperty('--compare-position', `${range.value}%`);
    };

    range.addEventListener('input', update, { signal: this.#ac.signal });
    update();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-compare-slider')) {
  customElements.define('s-compare-slider', SCompareSlider);
}
